import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { RenderBlock } from "@/pages/FunnelEditor";

export default function PublicLanding() {
  const { slug } = useParams();
  const [funnel, setFunnel] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get(`/public/funnels/${slug}`).then(({ data }) => setFunnel(data)).catch(() => setFunnel(false));
  }, [slug]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/public/funnels/${slug}/submit`, form);
      setDone(true);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (funnel === false) return <div className="min-h-screen flex items-center justify-center bg-[var(--peak-bg)]"><div className="section-label">Page not found</div></div>;
  if (!funnel) return <div className="min-h-screen flex items-center justify-center bg-[var(--peak-bg)]"><div className="section-label">Loading…</div></div>;

  return (
    <div className="min-h-screen bg-[var(--peak-bg)]" data-testid="public-landing-page">
      <div className="max-w-3xl mx-auto p-6 md:p-16">
        <div className="section-label mb-6">Peak · Landing</div>
        {funnel.blocks.map((b) => (
          <div key={b.id} className="mb-8">
            {b.type === "form" ? (
              <form onSubmit={submit} className="border border-[var(--peak-ink)] p-6 bg-white" id="form" data-testid="landing-form">
                <div className="font-heading font-bold text-2xl uppercase tracking-tighter mb-4">{b.props?.title || "Form"}</div>
                {done ? (
                  <div className="section-label text-[#008A27]" data-testid="landing-success">Thanks — we'll be in touch.</div>
                ) : (
                  <div className="space-y-3">
                    <input required data-testid="landing-name" className="brutalist-input" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    <input required type="email" data-testid="landing-email" className="brutalist-input" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                    <input data-testid="landing-phone" className="brutalist-input" placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                    <textarea rows={3} data-testid="landing-message" className="w-full border border-[var(--peak-border)] p-2" placeholder="Message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                    <button type="submit" data-testid="landing-submit" className="bg-[var(--peak-accent)] hover:bg-black text-white font-bold uppercase tracking-widest px-6 py-3">{b.props?.cta || "Submit"}</button>
                  </div>
                )}
              </form>
            ) : (
              <RenderBlock block={b} />
            )}
          </div>
        ))}
        <div className="section-label mt-16 pt-6 border-t border-[var(--peak-border)]">Powered by Peak CRM</div>
      </div>
    </div>
  );
}
